export default {
  navContainer: ({ props }) => ({
    class: [
      // Position
      'relative ',
      // Misc
      { 'overflow-hidden': props.scrollable }
    ]
  }),
  navContent: {
    class: [
      // Overflow and Scrolling
      'overflow-y-hidden overscroll-contain',
      'overscroll-auto',
      'scroll-smooth',
      '[&::-webkit-scrollbar]:hidden'
    ]
  },
  previousButton: {
    class: [
      // Flexbox and Alignment
      'flex items-center justify-center',

      // Position
      '!absolute',
      'top-0 left-0',
      'z-20',

      // Size and Shape
      'h-full w-12',
      'rounded-none',

      // Colors
      'bg-neutral-0 dark:bg-neutral-800',
      'text-primary-500 dark:text-primary-400',
      'shadow-md'
    ]
  },
  nextButton: {
    class: [
      // Flexbox and Alignment
      'flex items-center justify-center',

      // Position
      '!absolute',
      'top-0 right-0',
      'z-20',

      // Size and Shape
      'h-full w-12',
      'rounded-none',

      // Colors
      'bg-neutral-0 dark:bg-neutral-800',
      'text-primary-500 dark:text-primary-400',
      'shadow-md'
    ]
  },
  nav: {
    class: [
      // Flexbox
      'inline-flex rounded-lg bg-white',

      // Spacing
      'list-none',
      'pb-0 m-0',

      // Colors
      'bg-neutral-0 dark:bg-neutral-800',
      'border-b-0 border-neutral-100 dark:border-neutral-700',
      'text-neutral-900 dark:text-neutral-0/80'
    ]
  },
  tabpanel: {
    header: ({ props }) => ({
      class: [
        // Spacing
        'mr-0',
        'uppercase',
        // Misc
        {
          'opacity-60 cursor-default user-select-none select-none pointer-events-none':
            props?.disabled
        }
      ]
    }),
    headerAction: ({ parent, context }) => ({
      class: [
        'relative',

        // Font
        'font-medium tracking-tight',

        // Flexbox and Alignment
        'flex items-center',

        // Spacing
        'px-6 py-4',
        '-mb-[0.5px]',

        // Shape
        'border-b-2 hover:bg-neutral-200',
        '',

        // Colors and Conditions
        {
          'border-neutral-200 dark:border-neutral-700':
            parent.state.d_activeIndex !== context.index,
          'bg-neutral-0 dark:bg-neutral-800': parent.state.d_activeIndex !== context.index,
          'text-neutral-700 dark:text-neutral-0/80': parent.state.d_activeIndex !== context.index,

          'bg-neutral-0': parent.state.d_activeIndex === context.index,
          'active border-primary-default dark:border-primary-400':
            parent.state.d_activeIndex === context.index,
          'text-primary-500 dark:text-primary-400': parent.state.d_activeIndex === context.index
        },

        // States
        'focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:ring focus-visible:ring-inset',
        'focus-visible:ring-primary-400/50 dark:focus-visible:ring-primary-300/50',
        {
          'hover:bg-neutral-0 dark:hover:bg-neutral-800/80':
            parent.state.d_activeIndex !== context.index,
          'hover:border-neutral-400 dark:hover:border-primary-400':
            parent.state.d_activeIndex !== context.index,
          'hover:text-neutral-900 dark:hover:text-neutral-0':
            parent.state.d_activeIndex !== context.index
        },

        // Transitions
        'transition-all duration-200',

        // Misc
        'cursor-pointer select-none text-decoration-none',
        'overflow-hidden',
        'user-select-none'
      ]
    }),
    headerTitle: {
      class: [
        // Text
        'leading-none',
        'whitespace-nowrap'
      ]
    },
    content: {
      class: [
        // Spacing
        'p-0',

        // Shape
        'rounded-b-md',

        // Colors
        'bg-neutral-0 dark:bg-neutral-800',
        'text-neutral-700 dark:text-neutral-0/80',
        'border-0'
      ]
    }
  }
}
